//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("cisDossier", CisDossierFactory);

    CisDossierFactory.$inject = ["apiClientFactory"];
    function CisDossierFactory(apiClientFactory) {

        const routePrefix = "api/Cis/";

        return {
            Get: apiClientFactory.get(routePrefix),
            GetCisDossiersForOrganisation: apiClientFactory.get(routePrefix + "ForOrganisation/"),
            GetRequests: apiClientFactory.get(routePrefix + "Requests/"),
            Mine: apiClientFactory.get(routePrefix + "Mine/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
        };
    }
})();
